module.exports = __webpack_public_path__ + "assets/TB-DB_icon_heartbeat.svg";